export default "__VITE_ASSET__81IgdSWd__"